import { render, staticRenderFns } from "./WebhookEventDetail.vue?vue&type=template&id=5257191d&scoped=true"
import script from "./WebhookEventDetail.vue?vue&type=script&lang=js"
export * from "./WebhookEventDetail.vue?vue&type=script&lang=js"
import style0 from "./WebhookEventDetail.vue?vue&type=style&index=0&id=5257191d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5257191d",
  null
  
)

export default component.exports